// extracted by mini-css-extract-plugin
module.exports = {"container":"Products_container__XU0bX","product":"Products_product__t11P_","productActive":"Products_productActive__n_Pbp"};